import popular from '@/ui/assets/icons/iconsCategories/Popular.svg';
import CopaHelado from '@/ui/assets/icons/iconsCategories/CopaHelado.svg';
import pastel from '@/ui/assets/icons/iconsCategories/Pastel.svg';
import waffle from '@/ui/assets/icons/iconsCategories/Waffles.svg';
import crepaDulce from '@/ui/assets/icons/iconsCategories/CrepaDulce.svg';
import especialidadesErmita from '@/ui/assets/icons/iconsCategories/EspecialidadesErmita.svg';
import bebidasFrias from '@/ui/assets/icons/iconsCategories/BebidasFrias.svg';
import malteada from '@/ui/assets/icons/iconsCategories/Malteada.svg';
import bebidasConAlcohol from '@/ui/assets/icons/iconsCategories/BebidasConAlcohol.svg';
import bebidasCalientes from '@/ui/assets/icons/iconsCategories/BebidasCalientes.svg';
import deliciasDeSal from '@/ui/assets/icons/iconsCategories/DeliciasDeSal.svg';
import frame from '@/ui/assets/icons/Frame.svg';

export const icons = {
    popular,
    CopaHelado,
    pastel,
    waffle,
    crepaDulce,
    especialidadesErmita,
    bebidasFrias,
    malteada,
    bebidasConAlcohol,
    bebidasCalientes,
    deliciasDeSal,
    frame,
};